import { render, staticRenderFns } from "./FileCacheConfig.vue?vue&type=template&id=6e844910&"
import script from "./FileCacheConfig.vue?vue&type=script&lang=js&"
export * from "./FileCacheConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e844910')) {
      api.createRecord('6e844910', component.options)
    } else {
      api.reload('6e844910', component.options)
    }
    module.hot.accept("./FileCacheConfig.vue?vue&type=template&id=6e844910&", function () {
      api.rerender('6e844910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/FileCacheConfig.vue"
export default component.exports